import { calendar_v3 } from "googleapis";
import { useEffect, useMemo, useRef, useState } from "react";
import { listCalendarEventsInRange } from "../lib/list-calendar-events-in-range";

export function useCalendarEventsInRange(options: {
  accessToken: string | null;
  startDate: Date;
  endDate: Date;
}) {
  const { accessToken, startDate, endDate } = options;

  const keyRef = useRef("");
  const [loading, setLoading] = useState(false);

  const [events, setEvents] = useState<calendar_v3.Schema$Event[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      if (!accessToken || loading || events.length > 0) {
        return;
      }

      const key = `${startDate.toISOString()}-${endDate.toISOString()}`;
      if (keyRef.current === key) {
        return;
      }
      keyRef.current = key;

      setLoading(true);
      const fetchedEvents = await listCalendarEventsInRange(
        accessToken,
        startDate,
        endDate
      );
      setEvents(fetchedEvents);
      setLoading(false);
    };
    if (accessToken) {
      fetchEvents();
    }
  }, [accessToken, startDate, endDate, events, loading]);

  return useMemo(() => {
    return {
      events,
      loading,
    };
  }, [events, loading]);
}
